import React, { useState, useRef } from 'react';
import PrimeReact from 'primereact/api';
import { InputSwitch } from 'primereact/inputswitch';

import 'primeicons/primeicons.css';
import './topbar.scss';
import DarkImg from './dark.png';
import LightImg from './light.png';

function Topbar(props) {
  const changeScroll = () => {
    if (window.scrollY > 1) {
      setBg('opaque');
    } else {
      setBg('');
    }
  }
  const [bg, setBg] = useState('');
  const toggleTheme = () => {
    props.toggleTheme();
  }
  window.addEventListener("scroll", changeScroll);
  return (
    <div className={"topbar " + bg} >
      <div className="switch-img-wrapper">
        <img className="switch-img" src={props.theme == 'light' ? LightImg : DarkImg} onClick={() => toggleTheme()} />
      </div>
      <div className="title">About Me</div>
      <a className="github-icon-wrapper" target="_blank" href="https://github.com/virajrg108">
        <i className="pi pi-github github-icon"></i>
      </a>
    </div>
  )
}

export default Topbar;